import { useTranslation } from 'react-i18next';
import { HalfCirclePoint } from '@/common/components/HalfCirclePoint/HalfCirclePoint';
import { LoadingPlaceholder } from '@/common/components/LoadingPlaceholder/LoadingPlaceholder';
import { PageLayout } from '@/common/components/PageLayout/PageLayout';
import { Stack } from '@/common/components/Stack/Stack';
import { InsuranceUpgradePlanBanner } from '@/common/containers/Dashboard/Insurance/components/InsuranceUpdgradePlanBanner/InsuranceUpgradePlanBanner';
import { IInsurancePolicy } from '@/common/integrations/menhir/employee/insurance/insurance.types';
import { tArray } from '@/common/utils/i18n';
import { useInsuranceMovements } from '@/web/hooks/useInsuranceMovements';
import { InsuranceHomeDetails } from './InsuranceHomeDetails/InsuranceHomeDetails';

export type TPTInsuranceHomeProps = {
  activePolicy?: IInsurancePolicy;
  upcomingPolicy?: IInsurancePolicy;
};

export function PTInsuranceHome({
  activePolicy,
  upcomingPolicy,
}: TPTInsuranceHomeProps) {
  const { t } = useTranslation();
  const { mergedMovements = [], isLoading } = useInsuranceMovements(
    activePolicy?.id
  );

  const helpUrl = t('help_link.faq.insurance');
  const exemptions = activePolicy?.holderPaymentMethodsAllowed.includes(
    'wallet'
  )
    ? tArray<string>('dashboard.insurance.benefits')
    : [];

  return (
    <PageLayout
      headerProps={{
        title: t('dashboard.insurance_detail.title'),
        infoButton: { as: 'a', href: helpUrl, hrefAttrs: { target: '_blank' } },
        description:
          exemptions.length > 0 ? (
            <Stack horizontal wrap rowGap="lg" columnGap="xs">
              {exemptions.map((exemption, idx) => (
                <HalfCirclePoint key={idx}>{exemption}</HalfCirclePoint>
              ))}
            </Stack>
          ) : undefined,
      }}
    >
      <InsuranceUpgradePlanBanner />
      {isLoading ? (
        <LoadingPlaceholder />
      ) : (
        <InsuranceHomeDetails
          activePolicy={activePolicy}
          upcomingPolicy={upcomingPolicy}
          hasMovements={mergedMovements.length > 0}
        />
      )}
    </PageLayout>
  );
}
